// extracted by mini-css-extract-plugin
export var cardSelected = "_hs-2";
export var image = "_hs-1";
export var table = "_hs-0";